// Evaluated just after Rapier's module (see ./index.ts): put FinalizationRegistry back.
const g = globalThis as { FinalizationRegistry?: unknown; __rapierSavedFR?: unknown };
g.FinalizationRegistry = g.__rapierSavedFR;
delete g.__rapierSavedFR;
export {};
